import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ACTIONS_TYPE, META_TYPE, PRIVATE_ROUTE } from 'utils/constants';
import ability from 'utils/ability/ability';
import { FeatureActivation } from 'features/components/FeatureActivation';
import { AppContext } from 'AppContext';
import InfoIcon from 'atoms/InfoIcon';
import { FormattedMessage } from 'react-intl';
import { FeatureDeactivation } from 'features/components/FeatureDeactivation';
import QuotesSettings from './QuotesSettings';

const Quotes = () => {
  const [activated, setActivated] = useState(
    ability.can('use', 'quotes_feature')
  );
  const { dispatch } = useContext(AppContext);
  const Title = () => (
    <InfoIcon
      title={<FormattedMessage id="settings.quotesSettings" />}
      contentKey={META_TYPE?.QUOTES}
    />
  );

  useEffect(() => {
    dispatch({ type: ACTIONS_TYPE.SETTING_TITLE, data: <Title /> });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!activated) {
    return (
      <div>
        <FeatureActivation
          featureKey="quotes_feature"
          setActivated={setActivated}
        />
      </div>
    );
  }

  return (
    <div>
      <QuotesSettings />
      <FeatureDeactivation
        featureKey="quotes_feature"
        setActivated={setActivated}
      />
    </div>
  );
};

export default {
  component: withRouter(Quotes),
  path: PRIVATE_ROUTE.SETTINGS.SUB_ROUTE.QUOTES_SETTINGS,
  key: 'quotes',
  abilityAction: 'manage',
  abilitySubject: 'quotes',
  icon: (
    <i data-eva="message-circle-outline" data-eva-height="20" data-eva-width="20"></i>
  ),
  text: <FormattedMessage id="settings.quotes" />,
};
